import { createAuthClient } from "better-auth/react";

import { API_URL } from "./env";

// Better Auth lives on the accounts API under /api/auth. The client manages the
// session cookie (cross-site in dev, so requests use credentials: "include").
export const authClient = createAuthClient({
  baseURL: `${API_URL}/api/auth`,
  fetchOptions: { credentials: "include" },
});

export const { signIn, signUp, signOut, useSession } = authClient;

/**
 * Kick off Microsoft (Entra) OAuth; Better Auth redirects out and back.
 * callbackURL must be ABSOLUTE — a bare "/" resolves against the auth host
 * (api.opsbelt.com) and 404s. Default to this dashboard's own origin (a trusted
 * origin in the server's auth config) so we land back here after sign-in.
 */
export function signInWithMicrosoft(callbackURL = window.location.origin) {
  return authClient.signIn.social({ provider: "microsoft", callbackURL });
}
